<div *ngIf="showBanner">
  <div *ngFor="let duplicate of duplicates" class="dupe-banner">
    <se-po-duplicate-banner-instance *ngIf="!duplicate.dismissed"
      [duplicate]="duplicate"
      (dismiss)="dismissBanner(duplicate)"
      (merge)="onMerge(duplicate)">
    </se-po-duplicate-banner-instance>
  </div>
</div>
